<template>
  <router-link
    :to="url"
    class="nav-link d-flex align-items-center"
    :class="{ active: isActive }"
  >
    <slot name="icon"></slot>
    <span class="nav-link-text ms-2">{{ navText }}</span>
  </router-link>
</template>

<script>
export default {
  name: "SidenavCollapse",
  props: {
    url: { type: String, required: true },
    collapse: { type: Boolean, default: false },
    collapseRef: { type: String, default: "" },
    navText: { type: String, required: true },
  },
  computed: {
    isActive() {
      return this.$route.path.startsWith(this.url);
    },
  },
};
</script>

<style scoped>
/* 🌤️ Style clair et moderne */
.nav-link {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #374151; /* gris bleuté élégant */
  background-color: transparent;
  margin: 4px 8px;
  transition: all 0.25s ease;
}

/* 🖱️ Hover doux */
.nav-link:hover {
  background-color: #f3f4f6; /* gris très clair */
  color: #111827;
}

/* ✅ Actif : gris clair chic */
.nav-link.active,
.router-link-exact-active {
  background-color: #e5e7eb; /* gris clair */
  color: #111827 !important; /* texte foncé */
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

/* 🧭 Icônes */
.material-icons-round {
  color: inherit;
  font-size: 18px;
}
</style>
